import Login from '@act/react-components/auth/AuthPages/Login';
import { Routes, SyncHook } from '../route-types';

const useSyncHook: SyncHook = null;

const routes: Routes = [{ path: '/login', element: <Login /> }];

const useNavigationHooks = () => {
  return {};
};

export const loginPageRouteConfig = {
  routes,
  useSyncHook,
  publicRoute: true,
  useNavigationHooks,
};
